import shortid from 'shortid';
import { StorageService } from 'app/services';
import { PRINT_OPTION_STORAGE_KEY } from '../../constants';
import * as ScriptRequestActions from '../actions';

// Safely parse localStorage data, fallback to null if not available
const getStorageData = () => {
  try {
    const storedValue = StorageService.getValue(PRINT_OPTION_STORAGE_KEY);
    return storedValue ? JSON.parse(storedValue) : null;
  } catch (error) {
    return null;
  }
};

const data = getStorageData();

const initialState = {
  filter: {
    patientGroupIds: [],
    weekNumber: '1',
    patientIds: [],
    doctorIds: [],
    repeatsLeft: 0,
    includeVPB: false,
    includeSuspendedPatient: false,
    isShowPacked: true,
    isShowNonPacked: false,
    isShowPackedPRN: false,
    isShowCeasedDeletedMed: false,
  },
  printOptions: {
    isPrintPerPatient: data?.isPrintPerPatient || false,
    isIncludeMedicationDetails: data?.isIncludeMedicationDetails || false,
    isRepeatsRemaining: data?.isRepeatsRemaining || false,
    includeScriptWithRepeatsLeft: data?.includeScriptWithRepeatsLeft || false,
    includedIds: [],
    excludedIds: [],
  },
  isIncludeVPB: false,
  printing: false,
  sending: false,
  loading: false,
  fileName: null,
  fileUrl: null,
  random: null,
  scriptItemsById: {},
};

const listReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    // SCRIPT_REQUEST_PRINT_REQUEST
    case ScriptRequestActions.SCRIPT_REQUEST_PRINT_REQUEST:
      return { ...state, printing: true };
    case ScriptRequestActions.SCRIPT_REQUEST_PRINT_REQUEST_SUCCESS:
      return { ...state, printing: false, ...payload };
    case ScriptRequestActions.SCRIPT_REQUEST_PRINT_REQUEST_FAIL:
      return { ...state, printing: false };
    case ScriptRequestActions.SCRIPT_REQUEST_SENDEMAIL_REQUEST:
      return { ...state, sending: true };
    case ScriptRequestActions.SCRIPT_REQUEST_SENDEMAIL_REQUEST_SUCCESS:
      return { ...state, sending: false };
    case ScriptRequestActions.SCRIPT_REQUEST_SENDEMAIL_REQUEST_FAIL:
      return { ...state, sending: false };

    // SCRIPT_REQUEST_CHANGE_FILTER
    case ScriptRequestActions.SCRIPT_REQUEST_CHANGE_FILTER:
      return {
        ...state,
        filter: { ...state.filter, ...payload },
        printOptions: { ...state.printOptions },
      };
    // SCRIPT_REQUEST_APPLY_PRINT_OPTIONS
    case ScriptRequestActions.SCRIPT_REQUEST_APPLY_PRINT_OPTIONS:
      return { ...state, printOptions: { ...state.printOptions, ...payload } };
    case ScriptRequestActions.SCRIPT_REQUEST_CHANGE_RANDOM:
      return { ...state, random: shortid(), scriptItemsById: {} };
    case ScriptRequestActions.SCRIPT_REQUEST_CLEAR_FILTER:
      return {
        ...state,
        filter: { ...initialState.filter },
        printOptions: initialState.printOptions,
        random: null,
        scriptItemsById: {},
      };
    case ScriptRequestActions.SCRIPT_REQUEST_CACHE_SCRIPT_LIST_ITEMS: {
      const nextById = { ...state.scriptItemsById };
      (payload || []).forEach((item) => {
        if (item?.id) {
          nextById[item.id] = {
            doctorName: item.doctorName,
            doctorEmail: item.doctorEmail,
          };
        }
      });
      return { ...state, scriptItemsById: nextById };
    }
    // SCRIPT_REQUEST_GET_INCLUDE_VPB
    case ScriptRequestActions.SCRIPT_REQUEST_GET_INCLUDE_VPB:
      return { ...state, loading: true };
    case ScriptRequestActions.SCRIPT_REQUEST_GET_INCLUDE_VPB_SUCCESS:
      return { ...state, isIncludeVPB: payload, loading: false };
    case ScriptRequestActions.SCRIPT_REQUEST_GET_INCLUDE_VPB_FAIL:
      return { ...state, loading: false };

    // SCRIPT_REQUEST_UPDATE_INCLUDE_VPB
    case ScriptRequestActions.SCRIPT_REQUEST_UPDATE_INCLUDE_VPB:
      return { ...state, loading: true };
    case ScriptRequestActions.SCRIPT_REQUEST_UPDATE_INCLUDE_VPB_SUCCESS:
      return {
        ...state,
        isIncludeVPB: payload,
        loading: false,
      };
    case ScriptRequestActions.SCRIPT_REQUEST_UPDATE_INCLUDE_VPB_FAIL:
      return { ...state, loading: false };

    // SCRIPT_REQUEST_GET_PRINT_OPTIONS
    case ScriptRequestActions.SCRIPT_REQUEST_GET_PRINT_OPTIONS:
      return { ...state, loading: true };
    case ScriptRequestActions.SCRIPT_REQUEST_GET_PRINT_OPTIONS_SUCCESS:
      return {
        ...state,
        printOptions: { ...state.printOptions, ...payload },
        loading: false,
      };
    case ScriptRequestActions.SCRIPT_REQUEST_GET_PRINT_OPTIONS_FAIL:
      return { ...state, loading: false };

    // SCRIPT_REQUEST_SAVE_PRINT_OPTIONS
    case ScriptRequestActions.SCRIPT_REQUEST_SAVE_PRINT_OPTIONS:
      return { ...state, loading: true };
    case ScriptRequestActions.SCRIPT_REQUEST_SAVE_PRINT_OPTIONS_SUCCESS:
      return {
        ...state,
        printOptions: { ...state.printOptions, ...payload },
        loading: false,
      };
    case ScriptRequestActions.SCRIPT_REQUEST_SAVE_PRINT_OPTIONS_FAIL:
      return { ...state, loading: false };

    // SCRIPT_REQUEST_CLEAR_HISTORY_FILE
    case ScriptRequestActions.SCRIPT_REQUEST_CLEAR_HISTORY_FILE:
      return { ...state, fileName: null, fileUrl: null };
    // SCRIPT_REQUEST_RESET
    case ScriptRequestActions.SCRIPT_REQUEST_RESET:
      return { ...initialState, printOptions: { ...state.printOptions } };
    default:
      return state;
  }
};

export default listReducer;
